import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';
import { ActionResponse } from 'types/ActivationOrderTypes';

export type signActivationOrderDataType = {
  id: string;
  body: {
    file_name: string;
    file_content: string;
  };
  successCallback?: (result: ActionResponse) => void;
  errorCallback?: Function;
  resultKey?: string;
};

export default ({
  id,
  body,
  successCallback,
  errorCallback,
  resultKey = 'signActivationOrderData',
}: signActivationOrderDataType) =>
  requestAsync({
    url: endpoints.getAOActionSignUrl(id),
    transform: (response: ActionResponse) => ({
      [resultKey]: response,
    }),
    queryKey: `${endpoints.getAOActionSignUrl(id)}`,
    body,
    options: {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
